import React from "react";
import { Link } from "react-router-dom";
import { booksPath, servicesPath } from "../lib/paths";

const T = {
  de: {
    lema: "Unabhängiger Verlag aus Oberösterreich. Erzählliteratur auf Spanisch und Deutsch.",
    verlag: "Verlag",
    books: "Bücher",
    services: "Werkstatt",
    about: "Über den Verlag",
    contact: "Kontakt",
    legalTitle: "Rechtliches",
    impressum: "Impressum",
    privacy: "Datenschutz",
    terms: "Nutzungsbedingungen",
    cookies: "Cookies",
    rights: "Alle Rechte vorbehalten.",
  },
  es: {
    lema: "Editorial independiente de Alta Austria. Narrativa en español y alemán.",
    verlag: "Editorial",
    books: "Libros",
    services: "Taller",
    about: "Sobre la editorial",
    contact: "Contacto",
    legalTitle: "Legal",
    impressum: "Aviso legal",
    privacy: "Privacidad",
    terms: "Términos de uso",
    cookies: "Cookies",
    rights: "Todos los derechos reservados.",
  },
};

export default function Footer({ language = "de" }) {
  const t = T[language];
  const p = `/${language}`;
  const link = "text-hueso/65 hover:text-hueso transition-colors";

  return (
    <footer className="bg-tinta text-hueso border-t border-borde">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          <div className="col-span-2 md:col-span-1">
            <img
              src="/sello-bwv.png"
              alt=""
              width="64"
              height="64"
              loading="lazy"
              className="w-14 h-14 opacity-80 mb-5"
            />
            <p className="font-vers tracking-[0.12em] text-hueso mb-4 leading-snug">
              Blauer Wolf Verlag
            </p>
            <p className="text-sm text-hueso/65 max-w-xs">{t.lema}</p>
          </div>

          <nav>
            <h2 className="rotulo text-lobo mb-5">{t.verlag}</h2>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to={booksPath(language)} className={link}>
                  {t.books}
                </Link>
              </li>
              <li>
                <Link to={servicesPath(language)} className={link}>
                  {t.services}
                </Link>
              </li>
              <li>
                <Link to={`${p}#verlag`} className={link}>
                  {t.about}
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h2 className="rotulo text-lobo mb-5">{t.contact}</h2>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href="mailto:office@bw-verlag.at"
                  className={link + " break-all"}
                >
                  office@bw-verlag.at
                </a>
              </li>
              <li className="text-hueso/65 leading-relaxed">
                Ober-Pabneukirchen&nbsp;17
                <br />
                4363&nbsp;Pabneukirchen
                <br />
                {language === "de" ? "Österreich" : "Austria"}
              </li>
            </ul>
          </div>

          <nav>
            <h2 className="rotulo text-lobo mb-5">{t.legalTitle}</h2>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to={`${p}/impressum`} className={link}>
                  {t.impressum}
                </Link>
              </li>
              <li>
                <Link to={`${p}/privacy`} className={link}>
                  {t.privacy}
                </Link>
              </li>
              <li>
                <Link to={`${p}/terms`} className={link}>
                  {t.terms}
                </Link>
              </li>
              <li>
                <Link to={`${p}/cookies`} className={link}>
                  {t.cookies}
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-14 pt-7 border-t border-borde flex flex-col sm:flex-row gap-3 justify-between text-xs text-hueso/60">
          <p>
            © {new Date().getFullYear()} Blauer Wolf Verlag. {t.rights}
          </p>
          <p className="font-vers tracking-vers">ISBN 978-3-9505928</p>
        </div>
      </div>
    </footer>
  );
}
